import { Stack } from '@mui/material';
import React from 'react';

import Icon from '@components/Icon/Icon';
import Selector from '@components/Selector';
import UnitPill from '@components/UnitPill';

import { useHealthChart } from '@hooks/useHealthChart';
import { useIsMobile } from '@hooks/useIsMobile';

import { MetricVisual } from '@models/graph';

import Filters from '../Filters';
import { IconParameterDialog } from '../Range/Dialog';

export default function VisualizationHeader() {
  const { code, view, loading, setView } = useHealthChart();
  const isMobile = useIsMobile();

  const handleViewChange = (checked: boolean) => setView(checked);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Selector
        changeSelection={handleViewChange}
        disabled={loading}
        isSelected={view === MetricVisual.Table}
        leftLabel={
          <Icon color="text.secondary" name="chart-simple" type="fas" />
        }
        rightLabel={<Icon color="text.secondary" name="table" type="fas" />}
        size="small"
      />

      <Stack direction="row" spacing={1} alignItems="center">
        {/* Sits with the data it labels rather than up in the title banner,
        where it read as a page control. */}
        <UnitPill code={code} disabled={loading} />
        {isMobile ? <IconParameterDialog /> : <Filters />}
      </Stack>
    </Stack>
  );
}
